import { render, staticRenderFns } from "./ReceiptInfo.vue?vue&type=template&id=64f2c10f&scoped=true"
import script from "./ReceiptInfo.vue?vue&type=script&lang=js"
export * from "./ReceiptInfo.vue?vue&type=script&lang=js"
import style0 from "./ReceiptInfo.vue?vue&type=style&index=0&id=64f2c10f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f2c10f",
  null
  
)

export default component.exports